__turbopack_context__.v({
  "checked": "switch-module-scss-module__HFAQ3a__checked",
  "switch": "switch-module-scss-module__HFAQ3a__switch",
  "thumb": "switch-module-scss-module__HFAQ3a__thumb",
});
